import { useQuery, useMutation } from 'convex/react';
import { api } from '../../api';

interface Level {
  _id: string;
  name: string;
  description?: string;
}

export const useUserLevel = () => {
  
  // Fetch all available levels
  const levels = useQuery(api.levels.list.all, {
    paginationOpts: { cursor: null, numItems: 100 }
  });
  
  // For now, user level would need to be implemented in Convex backend

  const updateLevel = async (levelId: string) => {
    // This would need to be implemented as a Convex mutation
    console.log('Update level would be implemented here:', levelId);
    // For now, just log - actual implementation would need backend support
  };

  return {
    level: null, // Would need to be implemented in Convex backend
    levels: levels?.page || [],
    updateLevel,
    isLoading: levels === undefined,
    refetch: () => {
      // Convex handles refetching automatically
    },
  };
};